/* Deferred images.

   1. Panels that start closed: the desktop mega menu, the mobile menu drawer, the
      header search panel and the cart drawer. Closed panels are still laid out at
      the top of the page (hidden with visibility or pushed off-canvas), so
      loading="lazy" doesn't hold them back and they download on every page load,
      competing with the hero and the images actually on screen. Their <img> tags
      carry data-bb-src / data-bb-srcset and get the real attributes once the page
      has finished loading, or straight away on the shopper's first tap/key press.
      The desktop mega menu panels go earlier: as soon as the hero image is in, or
      on the first hover/focus of a menu item (that item's panel first, at high
      priority), so the menu isn't left waiting behind the rest of the page.

   2. Product cards' second (hover) image: data-bb-hover-src / data-bb-hover-srcset.
      Only devices that can hover ever show it, so touch screens never download it.
      On a card that is itself deferred (search panel), it waits for that card's
      main image. */
(function () {
  var DEFER = 'data-bb-';
  var HOVER = 'data-bb-hover-';
  var DEFER_SELECTOR = 'img[data-bb-src], img[data-bb-srcset]';
  var HOVER_SELECTOR = 'img[data-bb-hover-src], img[data-bb-hover-srcset]';
  var released = false;
  var panelsReleased = false;
  var hoverQuery = window.matchMedia('(hover: hover)');

  function swap(img, prefix) {
    var srcset = img.getAttribute(prefix + 'srcset');
    var src = img.getAttribute(prefix + 'src');
    if (srcset) {
      img.setAttribute('srcset', srcset);
      img.removeAttribute(prefix + 'srcset');
    }
    if (src) {
      img.setAttribute('src', src);
      img.removeAttribute(prefix + 'src');
    }
  }

  function swapHover(img) {
    if (!hoverQuery.matches) return;
    if (img.parentNode && img.parentNode.querySelector(DEFER_SELECTOR)) return;
    swap(img, HOVER);
  }

  function swapWithin(node) {
    var i, imgs;
    if (released) {
      if (node.matches(DEFER_SELECTOR)) swap(node, DEFER);
      imgs = node.querySelectorAll(DEFER_SELECTOR);
      for (i = 0; i < imgs.length; i++) swap(imgs[i], DEFER);
    }
    if (node.matches(HOVER_SELECTOR)) swapHover(node);
    imgs = node.querySelectorAll(HOVER_SELECTOR);
    for (i = 0; i < imgs.length; i++) swapHover(imgs[i]);
  }

  var header = null;
  var PAGE_EVENTS = ['pointerdown', 'keydown', 'touchstart'];
  var NAV_EVENTS = ['pointerover', 'focusin'];

  function release() {
    if (released) return;
    released = true;
    PAGE_EVENTS.forEach(function (type) { window.removeEventListener(type, release, true); });
    stopNavWatch();
    swapWithin(document.documentElement);
  }

  function swapPanel(panel, urgent) {
    var imgs = panel.querySelectorAll(DEFER_SELECTOR);
    for (var i = 0; i < imgs.length; i++) {
      if (urgent) {
        imgs[i].setAttribute('fetchpriority', 'high');
        imgs[i].setAttribute('loading', 'eager');
      }
      swap(imgs[i], DEFER);
    }
  }

  // Mega menu panels (.bbh-nav__item[data-bbh-target] opens .bbh-panel[data-bbh-panel]
  // with the same value). urgentKey: the hovered item's panel, loaded first.
  function releasePanels(urgentKey) {
    stopNavWatch();
    var panels = document.querySelectorAll('.bbh-panel[data-bbh-panel]');
    var i;
    for (i = 0; i < panels.length; i++) {
      if (urgentKey !== null && panels[i].getAttribute('data-bbh-panel') === urgentKey) swapPanel(panels[i], true);
    }
    for (i = 0; i < panels.length; i++) swapPanel(panels[i], false);
  }

  function onNavIntent(event) {
    var item = event.target.closest && event.target.closest('.bbh-nav__item[data-bbh-target]');
    if (item) releasePanels(item.getAttribute('data-bbh-target'));
  }

  // On devices that can hover, the mega menu is often the first thing a shopper
  // reaches for, so its panels load as soon as the page's hero image is in rather
  // than at the end of the page load. Without a hero they wait for the load event.
  function releasePanelsAfterHero() {
    if (!hoverQuery.matches || panelsReleased) return;
    var hero = document.querySelector('#MainContent img[fetchpriority="high"]');
    if (!hero) return;
    if (hero.complete) {
      releasePanels(null);
      return;
    }
    var done = function () { releasePanels(null); };
    hero.addEventListener('load', done, { once: true });
    hero.addEventListener('error', done, { once: true });
  }

  function stopNavWatch() {
    if (panelsReleased) return;
    panelsReleased = true;
    if (header) NAV_EVENTS.forEach(function (type) { header.removeEventListener(type, onNavIntent); });
  }

  function releaseWhenIdle() {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(release, { timeout: 2000 });
    } else {
      setTimeout(release, 0);
    }
  }

  function start() {
    header = document.querySelector('.shopify-section-group-header-group');
    if (header && !panelsReleased) NAV_EVENTS.forEach(function (type) { header.addEventListener(type, onNavIntent, { passive: true }); });
    releasePanelsAfterHero();

    swapWithin(document.documentElement);

    // Content rendered later (slider clones, the cart drawer after an add to cart,
    // search results, filtered collection grids) arrives with the data attributes.
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) swapWithin(added[j]);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });

    if (hoverQuery.addEventListener) {
      hoverQuery.addEventListener('change', function () { swapWithin(document.documentElement); });
    }
  }

  PAGE_EVENTS.forEach(function (type) { window.addEventListener(type, release, { capture: true, passive: true }); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  if (document.readyState === 'complete') {
    releaseWhenIdle();
  } else {
    window.addEventListener('load', releaseWhenIdle);
  }
})();
